import React from 'react';
import { withApollo } from 'react-apollo';

import Flight from './Flight';
import { DetachFlight } from '../../../../mutations/DetachFlight';

const Flights = ({
  onClaimUpdated,
  hideLoading,
  showLoading,
  client,
  passengerTicketId,
  flights,
  flightId,
  onFlightTimeChange,
  onBlur,
  errors,
  touched,
  setFieldValue
}) => {
  const handleRemoveFlight = flightId => {
    showLoading();
    client
      .mutate({
        mutation: DetachFlight,
        variables: {
          input: {
            flightId,
            passengerTicketId
          }
        }
      })
      .then(({ data }) => {
        hideLoading();
        onClaimUpdated();
      })
      .catch(() => hideLoading());
  };

  const handleFlightChange = (id, e, { name, value }) => {
    setFieldValue(
      'flights',
      flights.map(f => (f.id === id ? { ...f, [name]: value } : f))
    );
  };

  const handleFlightTimeChange = (id, field, value) => {
    setFieldValue(
      'flights',
      flights.map(f => (f.id === id ? { ...f, [field]: value } : f))
    );
  };

  const flightsErrors = errors ? errors.flights : {};
  const flightsTouched = touched ? touched.flights : {};

  return flights.map((flight, index) => (
    <Flight
      key={flight.id}
      flight={flight}
      index={index}
      errors={flightsErrors ? flightsErrors[index] : undefined}
      touched={flightsTouched ? flightsTouched[index] : undefined}
      onFlightChange={handleFlightChange}
      onFlightTimeChange={handleFlightTimeChange}
      onBlur={onBlur}
      onRemoveFlight={handleRemoveFlight}
      removable={flight.id !== flightId}
    />
  ));
};

export default withApollo(Flights);



// WEBPACK FOOTER //
// ./src/component/ClaimForm/Form/Flights/index.js